var _jsxFileName = "/home/runner/_work/smpackages/smpackages/packages/webassets/src/components/Header/index.js",
  _this = this;
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Header as ExfoNavHeader } from '@sm/header';
import SMHeader from './Header';
import { HEADER_COLOR, HEADER_VARIANT } from './enums';
import { StaticContext } from '../StaticContext';
import { ValidMenuNameList } from './config/linkInfo';
var Header = function Header(_ref) {
  var actionFlow = _ref.actionFlow,
    alwaysUseAnonymousNav = _ref.alwaysUseAnonymousNav,
    color = _ref.color,
    ctaRedirectUrl = _ref.ctaRedirectUrl,
    displayLICTA = _ref.displayLICTA,
    excludeMenuItems = _ref.excludeMenuItems,
    lang = _ref.lang,
    Logo = _ref.Logo,
    isAnonHeaderSticky = _ref.isAnonHeaderSticky,
    isEUDC = _ref.isEUDC,
    isMRX = _ref.isMRX,
    isUserAuthenticated = _ref.isUserAuthenticated,
    showCreateSurveyButton = _ref.showCreateSurveyButton,
    showDrawer = _ref.showDrawer,
    showLoginButton = _ref.showLoginButton,
    showSignupButton = _ref.showSignupButton,
    title = _ref.title,
    user = _ref.user,
    variant = _ref.variant,
    wrenchVariant = _ref.wrenchVariant,
    joinTeamSlug = _ref.joinTeamSlug,
    joinTeamAmplitudeProps = _ref.joinTeamAmplitudeProps;
  var session = user === null || user === void 0 ? void 0 : user.session;
  var _useContext = useContext(StaticContext),
    _useContext$environme = _useContext.environment,
    _useContext$environme2 = _useContext$environme === void 0 ? {
      domain: 'surveymonkey',
      subdomain: 'www',
      tld: 'com'
    } : _useContext$environme,
    domain = _useContext$environme2.domain,
    subdomain = _useContext$environme2.subdomain,
    tld = _useContext$environme2.tld;
  // eslint-disable-next-line jsx-control-statements/jsx-use-if-tag
  return user.isAuthenticated && isUserAuthenticated ? /*#__PURE__*/React.createElement(ExfoNavHeader, {
    variant: wrenchVariant,
    title: title,
    isEUDC: isEUDC,
    session: session,
    languageCode: lang,
    domain: domain,
    subdomain: subdomain,
    tld: tld,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 43,
      columnNumber: 5
    }
  }) : /*#__PURE__*/React.createElement(SMHeader, {
    actionFlow: actionFlow,
    alwaysUseAnonymousNav: alwaysUseAnonymousNav,
    color: color,
    ctaRedirectUrl: ctaRedirectUrl,
    displayLICTA: displayLICTA,
    excludeMenuItems: excludeMenuItems,
    lang: lang,
    Logo: Logo,
    isAnonHeaderSticky: isAnonHeaderSticky,
    isEUDC: isEUDC,
    isMRX: isMRX,
    isUserAuthenticated: isUserAuthenticated,
    showCreateSurveyButton: showCreateSurveyButton,
    showDrawer: showDrawer,
    showLoginButton: showLoginButton,
    showSignupButton: showSignupButton,
    variant: variant,
    user: user,
    joinTeamSlug: joinTeamSlug,
    joinTeamAmplitudeProps: joinTeamAmplitudeProps,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 54,
      columnNumber: 5
    }
  });
};
Header.propTypes = {
  actionFlow: PropTypes.string,
  alwaysUseAnonymousNav: PropTypes.bool,
  color: PropTypes.oneOf(Object.values(HEADER_COLOR)),
  ctaRedirectUrl: PropTypes.string,
  displayLICTA: PropTypes.bool,
  excludeMenuItems: PropTypes.arrayOf(PropTypes.oneOf(ValidMenuNameList)),
  lang: PropTypes.string.isRequired,
  Logo: PropTypes.oneOfType([PropTypes.node, PropTypes.object]),
  isAnonHeaderSticky: PropTypes.bool,
  isEUDC: PropTypes.bool.isRequired,
  isMRX: PropTypes.bool,
  isUserAuthenticated: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  showCreateSurveyButton: PropTypes.bool,
  showDrawer: PropTypes.bool,
  showLoginButton: PropTypes.bool,
  showSignupButton: PropTypes.bool,
  title: PropTypes.string,
  user: PropTypes.object.isRequired,
  // eslint-disable-line react/forbid-prop-types
  variant: PropTypes.oneOf(Object.values(HEADER_VARIANT)),
  wrenchVariant: PropTypes.string,
  joinTeamSlug: PropTypes.string,
  joinTeamAmplitudeProps: PropTypes.shape({
    guestId: PropTypes.number,
    surveyId: PropTypes.number,
    surveyOwnerId: PropTypes.number
  })
};
Header.defaultProps = {
  actionFlow: 'header',
  alwaysUseAnonymousNav: false,
  color: 'primary',
  ctaRedirectUrl: '',
  displayLICTA: true,
  excludeMenuItems: [],
  Logo: undefined,
  isAnonHeaderSticky: true,
  isMRX: false,
  isUserAuthenticated: false,
  showCreateSurveyButton: true,
  showDrawer: true,
  showLoginButton: true,
  showSignupButton: true,
  title: undefined,
  variant: 'default',
  wrenchVariant: 'default',
  joinTeamSlug: undefined,
  joinTeamAmplitudeProps: {}
};
export default Header;
export { Header };
//# sourceMappingURL=index.js.map